document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      const deliveryElement = document.querySelector(".rte.delivery");
      const productForm = document.querySelector(".product-form");
      const actionContainer = document.querySelector(".product-actions.add-to-cart-enabled.add-to-cart-quantity-enabled");
      const paypalButton = document.querySelector(".paypal-buttons");

      if (!deliveryElement || !productForm || !actionContainer) return;

      const isOnDemand = deliveryElement.classList.contains("on-demand");

      // Entferne alte Nachricht, falls vorhanden
      const oldMessage = document.querySelector(".button-warning-message");
      if (oldMessage) oldMessage.remove();

      const children = actionContainer.querySelectorAll("*");

      if (isOnDemand) {
        // Alle Buttons und Elemente deaktivieren
        children.forEach(child => {
          child.style.cursor = "not-allowed";
          if (child.tagName === "BUTTON") {
            child.disabled = true;
            child.style.opacity = "0.5";
          }
        });

        if (paypalButton) {
          paypalButton.style.cursor = "not-allowed";
          paypalButton.style.pointerEvents = "none";
          paypalButton.style.opacity = "0.5";
        }

        // Hinweistext einfügen
        const message = document.createElement("div");
        message.textContent = "Beachte: Dieses Produkt ist nicht bestellbar – bitte kontaktiere uns bei Interesse";
        message.className = "button-warning-message";
        message.style.fontSize = "0.9em";
        message.style.color = "#a00";
        message.style.marginTop = "12px";
        message.style.fontStyle = "italic";
        message.style.textAlign = "left";

        productForm.parentElement.insertBefore(message, productForm.nextSibling);
      } 
    }, 200); // Verzögerung, damit DOM vollständig geladen ist
  });